import React from 'react';
import { TestTube, Plus } from 'lucide-react';

interface EmptySampleStateProps {
  onResetFilters?: () => void;
}

const EmptySampleState: React.FC<EmptySampleStateProps> = ({ onResetFilters }) => {
  return (
    <div className="text-center py-12 bg-white dark:bg-gray-800 shadow-sm rounded-lg">
      <TestTube className="h-12 w-12 text-gray-400 mx-auto mb-3" />
      <p className="text-gray-500 dark:text-gray-400">
        Keine Proben gefunden
      </p>
      {onResetFilters && (
        <button
          onClick={onResetFilters}
          className="mt-4 inline-flex items-center px-3 py-1.5 text-xs font-medium rounded-md text-primary-600 bg-primary-50 hover:bg-primary-100 dark:text-primary-400 dark:bg-primary-900/20 dark:hover:bg-primary-900/30"
        >
          Filter zurücksetzen
        </button>
      )}
    </div>
  );
};

export default EmptySampleState;